import {createStore, combineReducers, applyMiddleware} from 'redux';
//import { routerReducer } from 'react-router-redux';
//import logger from 'redux-logger';
import MultiAction from './middlewares/MultiAction'

import * as reducers from './reducers';

const reducer = combineReducers(reducers);
const createStoreWithMiddleware = applyMiddleware(
  MultiAction/*, logger*/
)(createStore);

const store = createStoreWithMiddleware(reducer, {
  categories: {
    idBySlug: {},
    tree: [],
    products: {},
    productList: [],
    searchResult: []
  },
  product: {
    byId: {},
    ids: [],
  },
  news: {
    byId: {},
    ids: [],
  },
  reviews: {
    byId: {},
    ids: [],
  },
  projects: {
    byId: {},
    ids: [],
  },
  cities: {
    byId: {},
    ids: [],
  },
  dealers: {
    byId: {},
    ids: [],
  },
  contacts: {},
  page: {},
  app: {
    alert: {
      visible: false,
      type: '',
      message: ' ',
    },
    cityList: [],
    contactInfo: {},
    loader: {
      visible: false
    }
  },
  cart: {}
}, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export default store;
